import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Tooltip } from 'react-wot-bootstrap'

import styles from './TextOverflow.scss'

class TextOverflow extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        classMix: PropTypes.string,
        withTooltip: PropTypes.bool,
        tooltipId: PropTypes.string,
        tooltipContent: PropTypes.node,
    }

    constructor(props) {
        super(props)

        this.state = {
            isTooltipEnabled: false,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.checkOverflow)
        this.checkOverflow()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkOverflow)
    }

    checkOverflow = () => {
        if (!this._base) return

        const isTooltipEnabled = (this._base.offsetWidth < this._base.scrollWidth)

        if (this.state.isTooltipEnabled !== isTooltipEnabled) {
            this.setState({
                isTooltipEnabled,
            })
        }
    }

    getTooltipContent = () => {
        const { tooltipContent, children } = this.props
        return (tooltipContent ? tooltipContent : children)
    }

    render() {
        const {
            children,
            classMix,
            withTooltip,
            tooltipId,
        } = this.props

        const { isTooltipEnabled } = this.state

        const baseClassName = classNames(
            styles.base,
            classMix
        )

        return (
            <div
                ref={c => this._base = c}
                className={baseClassName}
                data-tip={tooltipId}
                data-for={tooltipId}
            >
                {children}
                {withTooltip && isTooltipEnabled && (
                    <Tooltip
                        id={tooltipId}
                        getContent={this.getTooltipContent}
                    />
                )}
            </div>
        )
    }
}

TextOverflow.defaultProps = {
    withTooltip: true,
}

export default TextOverflow



// WEBPACK FOOTER //
// ./components/TextOverflow/TextOverflow.jsx